require('payrailz-ontrac-sdk-core/src/buildRoots/includePolyfills');
const ontracResources = require('payrailz-ontrac-sdk-core/src/ontracResources');
const Browser = require('../Payrailz/BrowserClient');

module.exports = Browser(ontracResources);
